import { merge } from 'cerebral/operators'
import { state } from 'cerebral/tags'

export default [
  merge(state`node.contextMenu`, { node: null, isVisible: false })
]



// WEBPACK FOOTER //
// ./src/modules/Node/chains/hideTreeContextMenu.js